/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Editors_Sleep_Quality_3Inputs */

const en_us2_profile_editors_sleep_quality_3 = /** @type {(inputs: Profile_Editors_Sleep_Quality_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fair`)
};

const pt_br2_profile_editors_sleep_quality_3 = /** @type {(inputs: Profile_Editors_Sleep_Quality_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regular`)
};

const es_419_profile_editors_sleep_quality_3 = /** @type {(inputs: Profile_Editors_Sleep_Quality_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regular`)
};

const pt_pt2_profile_editors_sleep_quality_3 = /** @type {(inputs: Profile_Editors_Sleep_Quality_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Razoável`)
};

const fr_fr2_profile_editors_sleep_quality_3 = /** @type {(inputs: Profile_Editors_Sleep_Quality_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Moyenne`)
};

const de_de2_profile_editors_sleep_quality_3 = /** @type {(inputs: Profile_Editors_Sleep_Quality_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mittel`)
};

const it_it2_profile_editors_sleep_quality_3 = /** @type {(inputs: Profile_Editors_Sleep_Quality_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Così così`)
};

/**
* | output |
* | --- |
* | "Fair" |
*
* @param {Profile_Editors_Sleep_Quality_3Inputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_sleep_quality_3 = /** @type {((inputs?: Profile_Editors_Sleep_Quality_3Inputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Sleep_Quality_3Inputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_sleep_quality_3(inputs)
	if (locale === "es-419") return es_419_profile_editors_sleep_quality_3(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_sleep_quality_3(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_sleep_quality_3(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_sleep_quality_3(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_sleep_quality_3(inputs)
	return en_us2_profile_editors_sleep_quality_3(inputs)
});
export { profile_editors_sleep_quality_3 as "profile-editors.sleep_quality_3" }